import React, { useContext, useRef, useState } from 'react'
import { useEffect } from "react";
import { Box, CssBaseline, IconButton, Tooltip, Typography } from "@mui/material";
import { ThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';
import customtheme from '../../themes';
import { MdPrint } from 'react-icons/md';
import { useReactToPrint } from 'react-to-print';

const PassengerInfo = ({ selectedPassenger, Ismali }) => {
  const customization = useSelector((state) => state.customization);

  useEffect(() => {
  }, []);

  const rowStyle = {
    display: 'flex', justifyContent: 'flex-end', pb: 1, pt: 1, borderBottom: 'solid 1px rgb(28 117 101 / 41%)'
  };

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "چاپ اطلاعات مانیفست پرواز",
    onBeforePrint: () => { },
    onAfterPrint: () => { },
    removeAfterPrint: true,
  });

  return (
    <ThemeProvider theme={customtheme(customization)}>
      <div dir="rtl" >
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          
            <Tooltip title="چاپ اطلاعات زائر" placement="top">
              <IconButton style={{ margin: '2px', borderRadius: 0 }} onClick={() => {
                handlePrint(null, () => contentToPrint.current);
              }}>
                <MdPrint color='#4a148c' />
              </IconButton>
            </Tooltip>


    
          
        </Box>
        <div ref={contentToPrint} >
                  <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <Typography variant='h4' sx={{ display: "flex", alignItems: "center",mt:2 }}>{selectedPassenger?.name + ' ' + selectedPassenger?.family}</Typography>
          </Box>
          <div dir='rtl' style={{ padding: '10px', textAlign: 'center' }}>
            <Typography component="h1" variant="h5" sx={{ display: "flex", marginTop: 1, marginBottom: 1, alignItems: "center", backgroundColor: 'rgb(113 185 172 / 41%)', padding: 1, borderTop: 'solid 1px rgb(28 117 101 / 41%)', borderBottom: 'solid 1px rgb(28 117 101 / 41%)' }}>
              <Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>
                اطلاعات زائر
              </Box>
            </Typography>
            <CssBaseline />
            <Box sx={{ flex: '1 1 0px', mt: 2 }}>
               <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>مرحله اعزام</Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.stepTitle}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>نوع</Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.passengerTypeTitle}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>کد ملی </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.ssn}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>نام پدر </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.fatherName}</Box></Typography>
            </Box>
            <Box sx={{ flex: '1 1 0px' }}>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> گروه سنی </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.ageTypeTitle}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> جنسیت </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.sexTypeTitle}</Box></Typography>

            </Box>
            <Box sx={{ flex: '1 1 0px' }}>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> تاریخ تولد</Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.birthDate}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> محل تولد</Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.birthPlace}</Box></Typography>
            </Box>

            <Box sx={{ flex: '1 1 0px' }}>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شماره گذرنامه  </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.passNO}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شماره همراه  </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.mobileNO}</Box></Typography>

            </Box>
            <Box sx={{ flex: '1 1 0px' }}>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> مذهب </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.religionTitle}</Box></Typography>
              <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> ملیت </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.nationalityTitle}</Box></Typography>
            </Box>
            <>
              {

                Ismali && <div>
                  <Typography component="h1" variant="h5" sx={{ display: "flex", marginTop: 1, marginBottom: 1, alignItems: "center", backgroundColor: 'rgb(113 185 172 / 41%)', padding: 1, borderTop: 'solid 1px rgb(28 117 101 / 41%)', borderBottom: 'solid 1px rgb(28 117 101 / 41%)' }}>
                    <Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>
                      اطلاعات مالی
                    </Box>
                  </Typography>
                  <CssBaseline />
                  <Box sx={{ flex: '1 1 0px', marginTop: 2 }}>
                    <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شماره شبا </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.shebaAccount}</Box></Typography>
                    <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>  گروه قیمتی </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.priceGroupTitle}</Box></Typography>
                  </Box>
                </div>

              }
            </>
            <>
              {!Ismali && <div>
                <Typography component="h1" variant="h5" sx={{ display: "flex", marginTop: 1, marginBottom: 1, alignItems: "center", backgroundColor: 'rgb(113 185 172 / 41%)', padding: 1, borderTop: 'solid 1px rgb(28 117 101 / 41%)', borderBottom: 'solid 1px rgb(28 117 101 / 41%)' }}>
                  <Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>
                    اطلاعات پرواز و هتل
                  </Box>
                </Typography>
                <CssBaseline />
                <Box sx={{ flex: '1 1 0px', marginTop: 1 }}>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شماره کاروان </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.brokerNo}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> نام کاروان </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.brokerName}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', ttextAlign: 'center' }}> نام مدیر کاروان </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.managerName}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شماره همراه مدیر کاروان </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.managerMobileNO}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شرکت عربی </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.companyName}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> نام هتل مکه</Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger.meccaHotel}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> نام هتل مدینه</Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger.medinaHotel}</Box></Typography>
                </Box>

                <Box sx={{ flex: '1 1 0px', marginTop: 1 }}>

                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> شماره پرواز رفت </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.flightNo}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> فرودگاه مبدا </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.originName}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>  تاریخ پرواز رفت </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.flightDate}</Box></Typography>
                </Box>
                <Box sx={{ flex: '1 1 0px', marginTop: 1}}>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}> فرودگاه مقصد </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.destinationName}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>  شماره پرواز برگشت </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.returnFlightNo}</Box></Typography>
                  <Typography sx={rowStyle}><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>  تاریخ پرواز برگشت </Box><Box sx={{ flex: '1 1 0px', textAlign: 'center' }}>{selectedPassenger?.returnDate}</Box></Typography>
                </Box>
              </div>
              }
            </>
          </div>
        </div>
      </div>
    </ThemeProvider>

  )
}
export default PassengerInfo